import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";

const Layout = () => {
  const location = useLocation();

  const noFooterPages = ["/notes", "/maintainanceNotes"];
  const hideFooter = noFooterPages.includes(location.pathname);

  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
